import * as actions from '../Action/login'

export const initialState = {
    userName:"",
    password:"",
    loginStatus:null,
    tenantKey: null,
    tenantLoginStatus: null,
    userLoginStatus: null,
    loaderStatus:false,
    resetpasswordLoginStatus:null,
}

export default function reducer(state = initialState, action){
    switch(action.type){
        case actions.USERNAME : return userName(state,action);
        case actions.PASSWORD : return passWord(state,action);
        case actions.LOGINSUCCESS: return loginSussess(state,action)
        case actions.TENANTKEY: return tenantKey(state,action)
        case actions.TENANTLOGINSTATUS: return tenantLoginStatus(state,action)
        case actions.USERLOGINSTATUS: return userLoginStatus(state,action)
        case actions.LOGGEDINLOADER: return loggedInLoader(state,action)
        case actions.RESETPASSWORDLOGINSTATUS: return resetpasswordLoginStatus(state,action)
        default: return state
    }
}

const userName = (state,action) => {
    return {
        ...state,
        userName: action.payload
    }
}

const passWord = (state,action) => {
    return {
        ...state,
        password: action.payload
    }
}

const loginSussess = (state,action) => {
    return{
        ...state,
        loginStatus: action.payload
    }
}

const tenantKey = (state,action) => {
    return {
        state,
        tenantKey:action.payload
    }
}

const tenantLoginStatus = (state,action) => {
    return {
        ...state,
        tenantLoginStatus:action.payload
    }
}

const userLoginStatus = (state,action) => {
    debugger
    return {
        ...state,
        userLoginStatus: action.payload
    }
}

const loggedInLoader =(state,action) => {
    return{
        ...state,
        loaderStatus: action.payload
    }
}
const resetpasswordLoginStatus = (state,action) => {
    return {
        ...state,
        resetpasswordLoginStatus: action.payload
    }
}